import { Dispatch, useDispatch } from 'react-redux'
import CompanyForm from 'app-support/company/components/CompanyForm'
import { createCompany } from 'app-support/company/state/actions'
import { useTranslation } from 'react-i18next'
import { ICompany } from '@cbgms/api'
import { useNotifier } from '@cbgms/base/notifier'

const NewCompanyForm = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()

  const onSubmit = async (values: ICompany, _dispatch: Dispatch, _props: unknown) => {
    try {
      const { Data } = await dispatch(createCompany(values))

      return `/companies/edit/${Data.UUID}`
    } catch (error) {
      throw error
    }
  }

  const onSubmitSuccess = async () => {
    notifier.success(t('Company.SuccessfullyCreated'))
  }

  return (
    <CompanyForm shops={[]} onSubmit={onSubmit} onSubmitSuccess={onSubmitSuccess} form='company_new' isEdit={false} initialValues={{}} />
  )
}

export default NewCompanyForm
